export default "__VITE_ASSET__KpI2X5lp__"